module.exports = __webpack_public_path__ + "media/images/front/toppage_kyushudentalshow_pc-1bf24353f3f742092d18dd2da0e04c38.png";